/**
* MMap object
**/

import $ from "jquery"



class MMap {

  // ## Constructor ###
  constructor( options ) {
    // console.log("new map object", options);
    this.bradColor = options.brandColor ? options.brandColor : 'primary';
    this.$map = options.$map;
    this.$mapData = options.$mapData;
    this.id = options.id;
    this.markersArr = [];
    this.infoWindows = [];
    this.bounds = new google.maps.LatLngBounds();
    this.startPoint = new google.maps.LatLng(52.229676, 21.012229);
    this.startPointFromPlacemarkSet = false
    this.geocoder = new google.maps.Geocoder();
    this.markersLimit = 4;
    this.clusterGridSize = 40;
    this.dataRecordSelector = '.gmplacemark-mapdata';
    this.initializeMap();
    this.initPlacemarks();
    this.fitBounds();
  }


  getPlacemarkIcon(name = null) {
    const fileName = name ? name : "placemark"
    return '/local/images/' + fileName + '.png';
  }
  

  getMapOptions() {
    return {
      zoom: 17,
      scrollwheel: false,
      center: this.startPoint,
      disableDefaultUI: true,
      zoomControl: true,
      gestureHandling: "cooperative",
      styles: this.getMapStyles() // scroll down ;)
    };
  }

  // init map object
  initializeMap() {
    // console.log("initialize map", document.getElementById( this.id ));
    this.map = new google.maps.Map( document.getElementById( this.id ), this.getMapOptions() );
  }

  
  // init placemarks from $mapData
  initPlacemarks() {
    this.$mapData.find(this.dataRecordSelector).each( this.initPlacemark.bind(this) );
  }

  // init Placemark from DOM object
  initPlacemark(index, el) {
    let lat = parseFloat(el.dataset.lat);
    let lng = parseFloat(el.dataset.lng);    
    if (!lat || !lng) {
      return false;
    }
    // console.log("lat", lat, "lng", lng);
    let latlng = new google.maps.LatLng(lat, lng);
    let marker = new google.maps.Marker({
      position: latlng,
      map: this.map,
      icon: this.getPlacemarkIcon(el.dataset.placemark)
    });
    // set center to first placemark?
    if (!this.startPointFromPlacemarkSet) {
      this.map.setCenter(latlng)
      this.startPointFromPlacemarkSet = true
    }

    const markerId = el.dataset.id
    const mapURL = el.dataset.url
    const linkLabel = el.dataset.linkLabel
    let infoHtml = el.innerHTML
    if (mapURL && linkLabel) {
      infoHtml += '<a href="' + mapURL + '" target="_blank" class="venue-map-link">' + linkLabel + '</a>'
    }
    let infoWindow = new google.maps.InfoWindow({
      content: infoHtml
    })
    // // add event listeners
    marker.addListener('click', ()=>{
      infoWindow.open(this.map, marker)
    });

    infoWindow.markerId = markerId
    infoWindow.marker = marker
    this.infoWindows.push(infoWindow)

    this.bounds.extend(latlng);
    this.markersArr.push(marker);

  }

  openInfoWindowById(id, zoom = null) {
    const infoWindow = this.getInfoWindowById(id)
    if (infoWindow) {
      this.closeInfoWindows([id])
      if (infoWindow.marker) {
        infoWindow.open(this.map, infoWindow.marker)
        if (zoom) {
          this.zoomToMarker(infoWindow.marker, zoom)
        }
      }
    }
  }
  zoomToMarker(marker, zoom) {
    this.map.setZoom(zoom)
    this.map.panTo(marker.position)
  }

  closeInfoWindows(exceptions = []) {
    this.infoWindows.forEach((iw, index) => {
      if (exceptions.indexOf(iw.markerId) < 0) {
        iw.close()
      }
    })
  }

  getInfoWindowById(id) {
    let result = null
    this.infoWindows.forEach((iw, index) => {
      if (iw.markerId == id) {
        result = iw
      }
    })
    return result
  }



  // fit Bounds
  fitBounds() {
    if (this.markersArr.length < 1) {
      // console.log("fir bounds makes no sense");
      return false;
    } else if (this.markersArr.length == 1) {
      // only one marker - center on it
      let latlng = this.markersArr[0].getPosition();
      this.map.setCenter(latlng);
    } else {
      this.map.fitBounds( this.bounds );
    }
  }


  // ### Map Styles ###
  getMapStyles() {
    return [
      {
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#f5f5f5"
          }
        ]
      },
      {
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#616161"
          }
        ]
      },
      {
        "elementType": "labels.text.stroke",
        "stylers": [
          {
            "color": "#f5f5f5"
          }
        ]
      },
      {
        "featureType": "administrative.country",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "color": "#929292"
          }
        ]
      },
      {
        "featureType": "administrative.land_parcel",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#bdbdbd"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#eeeeee"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#757575"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#e5e5e5"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#9e9e9e"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#ffffff"
          }
        ]
      },
      {
        "featureType": "road.arterial",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#757575"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#dadada"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#616161"
          }
        ]
      },
      {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#9e9e9e"
          }
        ]
      },
      {
        "featureType": "transit.line",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#e5e5e5"
          }
        ]
      },
      {
        "featureType": "transit.station",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#eeeeee"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#c9c9c9"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#9e9e9e"
          }
        ]
      }
    ];
  }

}

export default MMap;

